import { Typography } from "@material-ui/core";
import React from "react";

function PlainTextRenderer({ id, settings }) {
  return (
    <>
      {settings.text.split("\n").map((t, i) => (
        <Typography key={i} variant={settings.variant}>
          {t}
        </Typography>
      ))}
    </>
  );
}

export default PlainTextRenderer;
